"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Button(_ref) {
  var direction = _ref.direction,
      onClick = _ref.onClick;
  var icon = direction === "forward" ? "angle-right" : "angle-left";
  var buttonClass = direction === "forward" ? "nav-button-next" : "nav-button-back";

  function handlerClick(e) {
    e.preventDefault();

    if (onClick) {
      onClick();
    }
  }

  return _react.default.createElement("button", {
    className: "nav-button  ".concat(buttonClass),
    onClick: handlerClick
  }, _react.default.createElement(_reactFontawesome.default, {
    name: icon
  }));
}

var _default = Button;
exports.default = _default;